import { createContext, useContext } from "react";
import { TWebsiteBuilderActivePageDomNodeRefMap } from "./hooks/activePageDomNodeRefMap/useActivePageDomNodeRefMapRegistration";
import { IWebsiteBuilderElementOperations } from "./hooks/nodeOperations/elementOperations/useWebsiteBuilderElementOperations";
import { IWebsiteBuilderClipboard } from "./hooks/clipboard/useWebsiteBuilderClipboard";
import { IWebsiteBuilderSectionOperations } from "./hooks/nodeOperations/sectionOperations/useWebsiteBuilderSectionOperations";
import { IWebsiteBuilderDesignSpaceBoundaries, TWebsiteBuilderDesignSpaceRef, TWebsiteBuilderScrollContainerRef } from "./WebsiteBuilderEditor";
import { TWebsiteBuilderOverlayLinesRef } from "./designSpace/overlay/WebsiteBuilderOverlay";
import { IWebsiteBuilderContainerOperations } from "./hooks/nodeOperations/containerOperations/useWebsiteBuilderContainerOperations";
import { THandleSetToolbarMenuType } from "./hooks/toolbarState/useWebsiteBuilderToolbarState";

export type TWebsiteBuilderTabsetActiveTabMap = Map<string, string>;

interface IWebsiteBuilderEditorContext {
  activePageDomNodeRefMap: TWebsiteBuilderActivePageDomNodeRefMap;
  tabsetActiveTabMap: TWebsiteBuilderTabsetActiveTabMap;
  updateTabsetActiveTab: (tabsetId: string, activeTabId: string) => void;
  removeTabsetActiveTab: (tabsetId: string) => void;
  elementOperations: IWebsiteBuilderElementOperations;
  containerOperations: IWebsiteBuilderContainerOperations;
  sectionOperations: IWebsiteBuilderSectionOperations;
  clipboard: IWebsiteBuilderClipboard;
  designSpaceBoundaries: IWebsiteBuilderDesignSpaceBoundaries;
  designSpaceRef: TWebsiteBuilderDesignSpaceRef;
  scrollContainerRef: TWebsiteBuilderScrollContainerRef;
  overlayLinesRef: TWebsiteBuilderOverlayLinesRef;
  websiteId: number;
  handleSetToolbarMenuType: THandleSetToolbarMenuType;
}

const defaultWebsiteBuilderEditorContext: IWebsiteBuilderEditorContext = {
  activePageDomNodeRefMap: null,
  tabsetActiveTabMap: new Map(),
  updateTabsetActiveTab: null,
  removeTabsetActiveTab: null,
  elementOperations: null,
  containerOperations: null,
  sectionOperations: null,
  clipboard: null,
  designSpaceBoundaries: null,
  designSpaceRef: null,
  scrollContainerRef: null,
  overlayLinesRef: null,
  websiteId: null,
  handleSetToolbarMenuType: null,
};

export const WebsiteBuilderEditorContext = createContext<IWebsiteBuilderEditorContext>(defaultWebsiteBuilderEditorContext);
export const useWebsiteBuilderEditorContext = () => useContext(WebsiteBuilderEditorContext);
